import { Snackbar, TextField } from "@material-ui/core";
// import http from "../../reduxSaga/sagas/requests/http-common";
import update from "immutability-helper";
// import Blob from "blob";
import Select from "react-select";
import makeAnimated from "react-select/animated";

import { useEffect, useState } from "react";

import { Alert } from "@material-ui/lab";
import React from "react";
import $ from "jquery";

import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Check from "@material-ui/icons/Check";
import SettingsIcon from "@material-ui/icons/Settings";

import Button from "@material-ui/core/Button";

import PurchaseService from "../../services/PurchaseOrder";
import CurrencyService from "../../services/CurrencyService";
import ProductService from "../../services/ProductService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import ManufacturingBatchService from "../../services/ManufacturingBatchService";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import UtilsFormule from "../../utils/UtilsFormule";
import { Link, useNavigate } from "react-router-dom";
import RateService from "../../services/RateService";
import WarehouseService from "../../services/WarehouseService";
import Societe from "../../services/Societe";
import SellingService from "../../services/SellingService";

const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
  },
  active: {
    color: "#000000",
  },
  circle: {
    width: 8,
    height: 8,
    color: "#fff",
    borderRadius: "50%",
    backgroundColor: "#000000",
  },
  completed: {
    color: "#000000",
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <Check className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,
};

const useColorlibStepIconStyles = makeStyles({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      backgroundColor: "#ccc",
      zIndex: 1,
      color: "#000",
      width: 50,
      height: 50,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  active: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      color: "#000000",
    },
  },
  completed: {
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SettingsIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,

  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      width: "100%",
      color: "#000000",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  icon: {
    color: "#000",
  },
}));

function getSteps() {
  return [
    "Inscrivez le devis " + sessionStorage.getItem("refDevis"),
    "Créer un bon de commande  ",
    "Finaliser",
  ];
}
const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const ValidateDevisToBCVente = () => {
  const navigate = useNavigate();

  const [availableProducts, setAvailableProducts] = useState([]);
  const [quotationReference, setQuotationReference] = useState("");
  const [bdcReference, setBdcReference] = useState("");
  const [clientId, setClientId] = useState(0);
  const [productId, setProductId] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [tva, setTva] = useState(0);
  const [promotion, setPromotion] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [productTableData, setProductTableData] = useState([]);
  // language of the source document: the document created from it keeps it
  const [documentLanguage, setDocumentLanguage] = useState("fr");
  const [productMapById, setProductMapById] = useState([]);
  const [promotionType, setPromotionType] = useState("pourcentage");
  const [discountType, setDiscountType] = useState("pourcentage");

  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();

  const [ordreTitle, setOrdreTitle] = useState("");
  const [ordreDateLimite, setOrdreDateLimite] = useState("any");
  const [ordreUrl, setOrdreUrl] = useState("any");
  const [bdcUrl, setBDCUrl] = useState("any");
  const [ordreDesignation, setOrdreDesignation] = useState("");

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const [infoAlertText, setInfoAlertText] = useState();
  const animatedComponents = makeAnimated();
  const classes = useStyles();
  const [selectedOption, setSelectedOption] = useState(null);
  const [clientSelectedOption, setClientSelectedOption] = useState(null);
  const [allProducts, setAllProducts] = React.useState([{}]);
  const [activeStep, setActiveStep] = React.useState(0);
  const [clientSelectPlaceHolder, setClientSelectPlaceHolder] =
    useState("Choisir...");

  const [createBDCFromDevis, setCreateBDCFromDevis] = useState(false);
  const [productSelectPlaceHolder, setProductSelectPlaceHolder] =
    useState("Choisir...");

  const [availableBDCSelectedOption, setAvailableBDCSelectedOption] =
    useState(null);
  const [allAvailableBDC, setAllAvailableBDC] = React.useState([{}]);
  const [availableBDCSelectPlaceHolder, setAvailableBDCSelectPlaceHolder] =
    useState("Choisir...");

  const [
    availableDevisNotRelatedToBDCSelectedOption,
    setAvailableDevisNotRelatedToBDCSelectedOption,
  ] = useState(null);
  const [
    allAvailableDevisNotRelatedToBdc,
    setAllAvailableDevisNotRelatedToBdc,
  ] = React.useState([{}]);
  const [
    availableDevisNotRelatedToBDCSelectPlaceHolder,
    setAvailableDevisNotRelatedToBDCSelectPlaceHolder,
  ] = useState("Choisir...");
  const [allModeProduct, setAllModeProduct] = React.useState([
    { value: 1, label: "Local" },
    { value: 2, label: "Import" },
  ]);
  const [selectedOptionMode, setSelectedOptionMode] = useState(null);
  const [modeProduct, setModeProduct] = useState(null);

  const [allCurrencies, setAllCurrencies] = React.useState([
    { value: "EUR", label: "Euro" },
    { value: "USD", label: "US Dollar" },
    { value: "AED", label: "United Arab Emirates Dirham" },
    { value: "CAD", label: "Canadian Dollar" },
    { value: "CNY", label: "Chinese Yuan" },
  ]);
  const [modeProductSelectPlaceHolder, setModeProductSelectPlaceHolder] =
    useState("Choisir...");
  const [clients, setClients] = useState([]);

  const [labelDevise, setLabelDevise] = useState("Prix en DNT");
  const [montantDevis, setMontantDevis] = useState(0);
  const [tauxChange, setTauxChange] = useState(0);
  const [deviseChoosen, setDeviseChoosen] = useState(null);
  const [selectedOptionDevis, setSelectedOptionDevis] = useState(null);
  const [deviseSelectPlaceHolder, setDeviseSelectPlaceHolder] =
    useState("Choisir...");
  const [availableLot, setAvailableLot] = useState([]);
  const [selectedOptionLot, setSelectedOptionLot] = useState(null);
  const [allLot, setAllLot] = useState([]);
  const [idLot, setIdLot] = useState(0);
  const [lotSelectPlaceHolder, setLotSelectPlaceHolder] =
    useState("Choisir...");
  const [promotionPercentage, setPromotionPercentage] = useState(0);
  const [bcPriceHt, setBcPriceHt] = useState(0);
  const [bcPriceTt, setBcPriceTt] = useState(0);
  const [initialPriceHTC, setInitialPriceHTC] = useState(0);
  const [buyingPrice, setBuyingPrice] = useState(0);
  const [priceTT, setPriceTT] = useState(0);
  const [discountFinal, setDiscountFinal] = useState(0);

  const [availableRates, setAvailableRates] = useState([]);
  const [allRates, setAllRates] = useState([]);

  const [rateSelectPlaceHolder, setRateSelectPlaceHolder] =
    useState("Choisir une taxe");
  const [rateChoosen, setRateChoosen] = useState(null);
  const [rateName, setRateName] = useState("");
  const [rateCode, setRateCode] = useState("");
  const [rateType, setRateType] = useState("");
  const [rateTypeTax, setRateTypeTax] = useState("");
  const [rateTypeTVA, setRateTypeTVA] = useState("");

  const [valueRate, setValueRate] = useState();
  const [refBill, setRefBill] = useState("");

  const [rateTableData, setRateTableData] = useState([]);
  const [selectedOptionRate, setSelectedOptionRate] = useState(null);
  const [allWarehouseSource, setAllWarehouseSource] = React.useState([{}]);
  const [warehousesSource, setWarehousesSource] = useState([]);
  const [warehouseSourceId, setWarehouseSourceId] = useState(0);
  const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
    useState("Choisir...");
  const [estimUnitPrice, setEstimUnitPrice] = useState("");
  const [estimQte, setEstimQte] = useState("");
  const [estimTva, setEstimTva] = useState("");
  const [estimDevise, setEstimDevise] = useState("");

  const [productBloc, setProductBloc] = useState(false);
  const [allClients, setAllClients] = useState([]);
  const [refBC, setRefBC] = useState("");
  const [bCFile, setBCFile] = useState([]);

  const steps = getSteps();

  $(".custom-file-input").on("change", function () {
    var fileName = $(this).val().split("\\").pop();
    $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
  });

  useEffect(() => {
    Societe.getSocietesClients("CLIENT", "CLIENT", 1, 0)
      .then((reponse) => {
        setClients(reponse.data["Societe"]);
      })
      .catch((e) => {
        setOpenErrorAlert(true);
        setErrorAlertText(
          "Erreur : il ya un probléme pour obtenir les clients"
        );
      });
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        if (response.data.success) {
          setWarehousesSource(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      });

    ManufacturingBatchService.getManufacturingBatchByIdUser(
      getCurrentUserId(),
      0
    ).then((response) => {
      setAvailableLot(response.data);
    });
    SellingService.getDevisByRef(
      sessionStorage.getItem("refDevis"),
      getCurrentUserId()
    )
      .then((response) => {
        console.log("responseDevis", response);
        setDocumentLanguage((response.data.success && response.data.success.language) || "fr");
        if (Object.keys(response.data)[0] === "success") {
          if (response.data.success.state === 0) {
            setProductMapById([]);
            setProductTableData([]);
            setWarehouseSourceId(response.data.success.idWarehouse);
            response.data.success.sales.forEach((element) => {
              let lot = 0;
              if (element.manufacturingBatch != null) {
                lot = element.manufacturingBatch.id;
              }
              setProductMapById((previoustate) => [
                ...previoustate,
                {
                  productRef: element.product.name,
                  idProduct: element.product.id,
                  initialPriceHtc: element.initialPriceHtc,
                  quantity: element.quantity,
                  tva: element.tva,
                  sellingPrice: element.sellingPrice,
                  idLot: lot,
                  currency: element.currency,
                  currencyPrice: element.currencyPrice,
                  exchangeRate: element.exchangeRate,
                  isImport: element.isImport,
                  htPrice: element.sellingPrice * element.quantity,
                  ttPrice: element.priceTt * element.quantity,
                  promotionPercentage: element.promotionPercentage,
                  note: element.note,
                },
              ]);
              setProductTableData((previoustate) => [
                ...previoustate,
                {
                  productRef: element.product.name,
                  idProduct: element.product.id,
                  initialPriceHtc: element.initialPriceHtc,
                  quantity: element.quantity,
                  tva: element.tva,
                  currency: element.currency,
                  currencyPrice: element.currencyPrice,
                  exchangeRate: element.exchangeRate,
                  isImport: element.isImport,
                  sellingPrice: element.sellingPrice,
                  idLot: lot,
                  htPrice: element.sellingPrice * element.quantity,
                  ttPrice: element.priceTt * element.quantity,
                  promotionPercentage: element.promotionPercentage,
                  note: element.note,
                },
              ]);
            });
            response.data.success.ratePPs.forEach((element) => {
              console.log("element", element);

              setRateTableData((previoustate) => [
                ...previoustate,
                {
                  idRate: element.idRate,
                  name: element.name,
                  value: element.value,
                  code: element.code,
                  type: element.type,
                  typeTax: element.typeTax,
                  typeTVA: element.typeTVA,
                  refBill: element.refBill,
                },
              ]);
            });

            setCreateBDCFromDevis(true);
            // setDiscountType("pourcentage");
            setDiscount(response.data.success.discountPercentage);
            setClientId(response.data.success.clientId);
            setClientSelectPlaceHolder(response.data.success.clientTitle);
            setBuyingPrice(response.data.success.buyingPrice);
          } else {
            setOpenInfoAlert(true);
            setInfoAlertText("Devis est deja confirmé");
          }
        } else if (Object.keys(response.data)[0] === "empty") {
          setOpenInfoAlert(true);
          setInfoAlertText("info : aucun devis  avec ce réference");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
    RateService.getAllRatesByIdUserAndIsDeletedAndTypeTax(
      getCurrentUserId(),
      0,
      1
    ).then((result) => {
      console.log("result", result.data["success"]);
      if (result.data["success"]) {
        setAvailableRates(result.data["success"]);
      } else {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :erreur serveur ");
      }
    });
  }, []);
  useEffect(() => {
    warehousesSource &&
      warehousesSource.map((element) => {
        let exist = false;
        if (allWarehouseSource.length !== 0) {
          for (let index = 0; index < allWarehouseSource.length; index++) {
            if (allWarehouseSource[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouseSource((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.name },
          ]);
        }
        //here
      });
  }, [warehousesSource]);

  useEffect(() => {
    availableLot &&
      availableLot.map((element) => {
        setAllLot((oldArray) => [
          ...oldArray,
          { value: element.id, label: element.serialNumber },
        ]);
      });
  }, [availableLot]);
  useEffect(() => {
    clients &&
      clients.map((element, i) => {
        let exist = false;
        if (allClients.length !== 0) {
          for (let index = 0; index < allClients.length; index++) {
            if (allClients[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }

        if (element?.id !== undefined && exist === false) {
          setAllClients((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.title },
          ]);
        }
      });
  }, [clients]);

  const onChangeSelectedWarehouseSource = (selectedOptionn) => {
    setSelectedOption();
    setWarehouseSourceId(selectedOptionn.value);
    setWarehouseSelectPlaceHolder(selectedOptionn.label);
    // console.log("warehouseSourceID", selectedOptionn.value);
  };
  useEffect(() => {
    setAllRates([]);

    availableRates &&
      availableRates.map((element, i) => {
        setAllRates((oldArray) => [
          ...oldArray,
          {
            value: element.id,
            label: element.name,
            customElements: {
              code: element.code,
              type: element.type,
              value: element.value,
              typeTVA: element.typeTVA,
              typeTax: element.typeTax,
            },
          },
        ]);
      });
  }, [availableRates]);

  useEffect(() => {
    if (ordreDateLimite === ":59") {
      setOrdreDateLimite("any");
    }
  }, [ordreDateLimite]);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const onChangeQuantityHandler = (event) => {
    setQuantity(event.target.value);
  };

  const onChangeOrdreTitleHandler = (event) => {
    setOrdreTitle(event.target.value);
  };

  //   const onChangeOrdreUrlHandler = (event) => {
  //     setOrdreUrl(event.target.value);
  //   };
  const onChangeBDCUrlHandler = (event) => {
    setBDCUrl(event.target.value);
  };
  const onChangeOrdreDesignationHandler = (event) => {
    setOrdreDesignation(event.target.value);
  };
  const onChangeLimitDateHandler = (event) => {
    setOrdreDateLimite(event.target.value.concat(":59"));
  };

  const onChangeUnitPriceHandler = (event) => {
    setUnitPrice(event.target.value);
    setLabelDevise("Prix U en DNT");
    setMontantDevis(event.target.value);
  };

  const onChangeTvaHandler = (event) => {
    setTva(event.target.value);
  };

  const onChangePromotionHandler = (event) => {
    setPromotionPercentage(event.target.value);
  };
  const onChangeDiscountHandler = (event) => {
    setDiscount(event.target.value);
    CalculateNewPurchasingPriceAfterDiscount(event.target.value, discountType);
  };

  const onChangeDiscountTypeHandler = (event) => {
    setDiscountType(event.target.value);
    CalculateNewPurchasingPriceAfterDiscount(discount, event.target.value);
  };
  const CalculateNewPurchasingPriceAfterDiscount = (discount, discountType) => {
    let result = UtilsFormule.CalculateNewPurchasingPriceAfterDiscount(
      productTableData,
      discount,
      discountType
    );
    console.log("result discount", result);
    let sumPromotionHt = result[1];
    let sumPromotionTt = result[2];
    let sumPriceHt = result[3];

    setBcPriceHt(sumPromotionHt);
    setBcPriceTt(sumPromotionTt);
    setInitialPriceHTC(sumPriceHt);
    setBuyingPrice(sumPromotionHt);
    setPriceTT(sumPromotionTt);
    setDiscountFinal(result[4]);
  };

  const onChangeQuotationReferenceHandler = (selectedOptionn) => {
    setQuotationReference(selectedOptionn.value);
    setAvailableDevisNotRelatedToBDCSelectedOption();

    setAvailableDevisNotRelatedToBDCSelectPlaceHolder(selectedOptionn.label);
  };

  const onChangeBDCReferenceHandler = (selectedOptionn) => {
    setBdcReference(selectedOptionn.value);
    setAvailableBDCSelectedOption();

    setAvailableBDCSelectPlaceHolder(selectedOptionn.label);
  };

  const onDeleteProduct = (id) => {
    setProductTableData(productTableData.filter((item) => item.id !== id));
    setProductMapById(productMapById.filter((item) => item.id !== id));
  };

  const onGetBDCByReference = () => {
    //here
    if (bdcReference === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Aucune réference");
    } else {
      SellingService.getBDCByRef(bdcReference, getCurrentUserId())
        .then((response) => {
          console.log("getBDCByRef", response.data.success);

          if (Object.keys(response.data)[0] === "success") {
            setProductMapById([]);
            setProductTableData([]);
            response.data.success.sales.forEach((element) => {
              let lot = 0;
              if (element.manufacturingBatch != null) {
                lot = element.manufacturingBatch.id;
              }
              setProductMapById((previoustate) => [
                ...previoustate,
                {
                  productRef: element.product.name,
                  idProduct: element.product.id,
                  initialPriceHtc: element.initialPriceHtc,
                  quantity: element.quantity,
                  tva: element.tva,
                  sellingPrice: element.sellingPrice,
                  idLot: lot,
                  currency: element.currency,
                  currencyPrice: element.currencyPrice,
                  exchangeRate: element.exchangeRate,
                  isImport: element.isImport,
                  htPrice: element.sellingPrice * element.quantity,
                  ttPrice: element.priceTt * element.quantity,
                  promotionPercentage: element.promotionPercentage,
                  note: element.note,
                },
              ]);

              setProductTableData((previoustate) => [
                ...previoustate,
                {
                  productRef: element.product.name,
                  idProduct: element.product.id,
                  initialPriceHtc: element.initialPriceHtc,
                  quantity: element.quantity,
                  tva: element.tva,
                  sellingPrice: element.sellingPrice,
                  idLot: lot,
                  currency: element.currency,
                  currencyPrice: element.currencyPrice,
                  exchangeRate: element.exchangeRate,
                  isImport: element.isImport,
                  htPrice: element.sellingPrice * element.quantity,
                  ttPrice: element.priceTt * element.quantity,
                  promotionPercentage: element.promotionPercentage,
                  note: element.note,
                },
              ]);
            });
            response.data.success.ratePPs.forEach((element) => {
              console.log("element", element);
              setRateTableData((previoustate) => [
                ...previoustate,
                {
                  idRate: element.idRate,
                  name: element.name,
                  value: element.value,
                  code: element.code,
                  type: element.type,
                  typeTax: element.typeTax,
                  typeTVA: element.typeTVA,
                  refBill: element.refBill,
                },
              ]);
            });
          } else if (Object.keys(response.data)[0] === "empty") {
            setOpenInfoAlert(true);
            setInfoAlertText(
              "info : aucun bon de commande  avec ce réference   "
            );
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        });
    }
  };

  const onGetDevisByReference = () => {
    if (quotationReference === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Aucune réference");
      setCreateBDCFromDevis(false);
      setProductMapById([]);
      setProductTableData([]);
    } else {
      SellingService.getDevisByRef(quotationReference, getCurrentUserId())
        .then((response) => {
          console.log("responseDevis", response);
          if (Object.keys(response.data)[0] === "success") {
            if (response.data.success.state === 0) {
              setProductMapById([]);
              setProductTableData([]);
              response.data.success.sales.forEach((element) => {
                let lot = 0;
                if (element.manufacturingBatch != null) {
                  lot = element.manufacturingBatch.id;
                }
                setProductMapById((previoustate) => [
                  ...previoustate,
                  {
                    productRef: element.product.name,
                    idProduct: element.product.id,
                    initialPriceHtc: element.initialPriceHtc,
                    quantity: element.quantity,
                    tva: element.tva,
                    sellingPrice: element.sellingPrice,
                    idLot: lot,
                    currency: element.currency,
                    currencyPrice: element.currencyPrice,
                    exchangeRate: element.exchangeRate,
                    isImport: element.isImport,
                    htPrice: element.sellingPrice * element.quantity,
                    ttPrice: element.priceTt * element.quantity,
                    promotionPercentage: element.promotionPercentage,
                    note: element.note,
                  },
                ]);
                setProductTableData((previoustate) => [
                  ...previoustate,
                  {
                    productRef: element.product.name,
                    idProduct: element.product.id,
                    initialPriceHtc: element.initialPriceHtc,
                    quantity: element.quantity,
                    tva: element.tva,
                    currency: element.currency,
                    currencyPrice: element.currencyPrice,
                    exchangeRate: element.exchangeRate,
                    isImport: element.isImport,
                    sellingPrice: element.sellingPrice,
                    idLot: lot,
                    htPrice: element.sellingPrice * element.quantity,
                    ttPrice: element.priceTt * element.quantity,
                    promotionPercentage: element.promotionPercentage,
                    note: element.note,
                  },
                ]);
              });
              response.data.success.ratePPs.forEach((element) => {
                console.log("element", element);

                setRateTableData((previoustate) => [
                  ...previoustate,
                  {
                    idRate: element.idRate,
                    name: element.name,
                    value: element.value,
                    code: element.code,
                    type: element.type,
                    typeTax: element.typeTax,
                    typeTVA: element.typeTVA,
                    refBill: element.refBill,
                  },
                ]);
              });
              setCreateBDCFromDevis(true);
              // setDiscountType("pourcentage");
              setDiscount(response.data.success.discountPercentage);
              setClientId(response.data.success.clientId);
              setClientSelectPlaceHolder(response.data.success.clientTitle);
              setBuyingPrice(response.data.success.buyingPrice);
            } else {
              setOpenInfoAlert(true);
              setInfoAlertText("Devis est deja confirmé");
            }
          } else if (Object.keys(response.data)[0] === "empty") {
            setOpenInfoAlert(true);
            setInfoAlertText("info : aucun devis  avec ce réference");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        });
    }
  };

  const handleNext = () => {
    if (activeStep === 0) {
      console.log("productTableData", productTableData);
      let result = UtilsFormule.CalculateNewPurchasingPriceAfterDiscount(
        productTableData,
        discount,
        discountType
      );
      console.log("result discount handleNext", result);

      let sumPromotionHt = result[1];
      let sumPromotionTt = result[2];
      let sumPriceHt = result[3];

      setBcPriceHt(sumPromotionHt);
      setBcPriceTt(sumPromotionTt);
      setInitialPriceHTC(sumPriceHt);
      setBuyingPrice(sumPromotionHt);
      setPriceTT(sumPromotionTt);
      setDiscountFinal(result[4]);
    }
    // if (activeStep === 0 && productBloc === false) {
    //   setOpenInfoAlert(true);
    //   setInfoAlertText(
    //     "Vous devez choisir un dépôt et appuyer sur le bouton flèche"
    //   );
    // } else
    if (activeStep === 0 && productTableData.length > 0) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else if (activeStep === 0 && productTableData.length === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Aucun produit ");
    } else if (activeStep === 1 && ordreTitle === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Le champ de titre est vide ");
    } else if (activeStep === 1 && clientId === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : aucun fournisseur ");
    } else if (activeStep === 1 && ordreDesignation === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : aucune description ");
    } else if (activeStep === 1) {
      SellingService.verifieBCSellExistanceByReference(
        getCurrentUserId(),
        refBC
      )
        .then((response) => {
          if (response.data["NotExist"]) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setProductTableData(
              UtilsFormule.CalculateNewPurchasingDataTableAfterDiscount(
                productTableData,
                discountFinal
              )
            );
          } else if (response.data["Exist"]) {
            setOpenInfoAlert(true);
            setInfoAlertText("Info : ce réference existe dans le system");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        });
      // setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else if (activeStep === 2) {
      // if (createBDCFromDevis === false) {
        var bdcModel = {};
        if (discountType === "percentage") {
        } else {
          if (discount === 0) {
          } else {
          }
        }
        bdcModel = {
          ref: refBC,
          buyingPrice: buyingPrice,
          description: ordreDesignation,
          discountPercentage: discountFinal,
          idClient: clientId,
          refDevis: sessionStorage.getItem("refDevis"),
          idUser: getCurrentUserId(),
          initialPriceHtc: initialPriceHTC,
          note: ordreDesignation,
          path: "any",
          priceHT: bcPriceHt,
          priceTT: bcPriceTt,
          sales: UtilsFormule.CalculateNewPurchasingDataTableAfterDiscount(
            productTableData,
            discountFinal
          ),
          title: ordreTitle,
          language: documentLanguage,
          ratePPps: rateTableData,
          warehouseId: warehouseSourceId,
        };
      // } else {
      //   bdcModel = {
      //     description: ordreDesignation,
      //     refDevis: sessionStorage.getItem("refDevis"),
      //     idUser: getCurrentUserId(),
      //     note: ordreDesignation,
      //     path: "any",
      //     title: ordreTitle,
      //     initialPriceHtc: initialPriceHTC,
      //     ref: refBC,
      //     sales: UtilsFormule.CalculateNewPurchasingDataTableAfterDiscount(
      //       productTableData,
      //       discountFinal
      //     ),
      //     ratePPps: rateTableData,
      //     warehouseId: warehouseSourceId,
      //   };
      // }

      console.log(JSON.stringify(bdcModel));
      if (bCFile.length !== 0) {
        const uploadData = new FormData();
        uploadData.append("picture", bCFile);

        SellingService.uploadFile("/uploadFile/BonCommandeSale", uploadData)
          .then((response) => {
            if (Object.keys(response.data)[0] === "success") {
              bdcModel.path = response.data.success;
              onSendQuotationToBackendSystem(bdcModel);
            } else {
              setOpenErrorAlert(true);
              setErrorAlertText("Erreur : il ya un erreur  ");
            }
          })
          .catch(() => {
            setOpenErrorAlert(true);
            setErrorAlertText(
              "Erreur : erreur lors de l'enregistrment du fichier"
            );
          });
      } else {
        onSendQuotationToBackendSystem(bdcModel);
      }
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    PurchaseService.getAllBDCNotArchived()
      .then((response) => {
        if (Object.keys(response.data)[0] === "empty") {
          setAvailableBDCSelectPlaceHolder("Vide");
        } else if (Object.keys(response.data)[0] === "success") {
          let backendData = [{}];
          response.data.success.map((element) => {
            let elem = { value: element, label: element };
            backendData.push(elem);
          });
          setAllAvailableBDC(backendData);
          setAvailableBDCSelectPlaceHolder("Choisir...");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });

    PurchaseService.getAllDevisNotRelatedToBDCeNotArchived()
      .then((response) => {
        if (Object.keys(response.data)[0] === "empty") {
          setAvailableDevisNotRelatedToBDCSelectPlaceHolder("Vide");
        } else if (Object.keys(response.data)[0] === "success") {
          let backendData = [{}];
          response.data.success.map((element) => {
            let elem = { value: element, label: element };
            backendData.push(elem);
          });
          setAllAvailableDevisNotRelatedToBdc(backendData);
          setAvailableDevisNotRelatedToBDCSelectPlaceHolder("Choisir...");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });

    setCreateBDCFromDevis(false);
    setProductMapById([]);
    setProductTableData([]);
    setUnitPrice(0);
    setQuantity(0);
    setTva(0);
    setPromotion(0);
    setActiveStep(0);
  };

  const onChangeSelectedProduct = (selectedOptionn) => {
    console.log("selectedOptionn", selectedOptionn);
    setSelectedOption();
    setProductId(selectedOptionn.value);
    setProductSelectPlaceHolder(selectedOptionn.label);
    setEstimUnitPrice(selectedOptionn.customElements.price);
    setEstimQte(selectedOptionn.customElements.quantity);
    setEstimTva(selectedOptionn.customElements.tva);
    setEstimDevise(selectedOptionn.customElements.devise);
    setUnitPrice(selectedOptionn.customElements.price);
    setMontantDevis(selectedOptionn.customElements.price);
    setTva(selectedOptionn.customElements.tva);
  };
  const onChangeSelectedClient = (selectedOptionn) => {
    setSelectedOption();
    setClientId(selectedOptionn.value);
    setClientSelectPlaceHolder(selectedOptionn.label);
  };

  const onSendQuotationToBackendSystem = (bdcModel) => {
    console.log("bdcModel", JSON.stringify(bdcModel));
    SellingService.addBC(bdcModel)
      .then((response) => {
        if (Object.keys(response.data)[0] === "Bon_De_Commande") {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          setTimeout(() => {
            navigate(`/bonCommandeVente`);
          }, 2000);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un erreur  ");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connexion");
      });
  };
  const labelDeviseTest = () => {
    return labelDevise;
  };
  const onChangeMontantDevisHandler = (event) => {
    setMontantDevis(0);
    setMontantDevis(event.target.value);
  };
  const onHandleClickTauxChange = () => {
    if (deviseChoosen !== null) {
      getCurrencyRate(deviseChoosen);
    }
  };
  const getCurrencyRate = (deviseChoosen) => {
    try {
      CurrencyService.getTauxChage(deviseChoosen).then((response) => {
        setTauxChange(response.data);
        setLabelDevise(
          "TAUX D'ECH (" +
            response.data.toLocaleString(undefined, {
              maximumFractionDigits: 3,
            }) +
            ") ESTI DNT (" +
            (unitPrice * response.data).toLocaleString(undefined, {
              maximumFractionDigits: 3,
            }) +
            " )"
        );
      });
    } catch (error) {
      console.log("error currency", error);
    }
  };
  const calculDevis = () => {
    return (
      <div className="col-sm-6">
        <div className="input-group">
          <label>{labelDeviseTest()}</label>
          <div className="input-group-prepend" style={{ width: "89%" }}>
            <input
              onChange={onChangeMontantDevisHandler}
              type="number"
              min="0"
              id="montantDevise"
              className="form-control"
            />
          </div>
          <div className=" input-group-append">
            <button
              onClick={onHandleClickTauxChange}
              type="button"
              class="btn btn-dark"
            >
              {" "}
              <i class="fas fa-solid fa-dollar-sign"></i>{" "}
            </button>
          </div>
        </div>
      </div>
    );
  };
  const onChangeSelectedLot = (selectedOptionn) => {
    setSelectedOptionLot();
    setIdLot(selectedOptionn.value);
    setLotSelectPlaceHolder(selectedOptionn.label);
  };
  const onChangeSelectedDevis = (selectedOptionn) => {
    setSelectedOptionDevis(selectedOptionn.value);
    setDeviseChoosen(selectedOptionn.value);
    setDeviseSelectPlaceHolder(selectedOptionn.label);
  };
  const devise = () => {
    if (modeProduct === 2) {
      return (
        <div className="col-sm-8">
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label>Devise</label>
                <Select
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  defaultValue={selectedOptionDevis}
                  onChange={onChangeSelectedDevis}
                  options={allCurrencies}
                  placeholder={deviseSelectPlaceHolder}
                />
              </div>
            </div>
            {calculDevis()}
          </div>
        </div>
      );
    }
  };
  const onChangeSelectedMode = (selectedOptionn) => {
    setSelectedOptionMode(selectedOptionn.value);
    setModeProduct(selectedOptionn.value);
    setModeProductSelectPlaceHolder(selectedOptionn.label);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const columns = [
    {
      dataField: "productRef",
      text: "Libellé",
      headerAlign: "center",
    },
    {
      dataField: "initialPriceHtc",
      text: "Prix.U.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "sellingPrice",
      text: "Prix.U.V",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "note",
      text: "Note",
      headerAlign: "center",
      formatter: (cell) => cell || "",
    },
    {
      dataField: "quantity",
      text: "Qte",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "6%" };
      },
    },
    {
      dataField: "tva",
      text: "TVA",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "6%" };
      },
    },
    {
      dataField: "htPrice",
      text: "Montant.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "ttPrice",
      text: "Montant.TT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "promotionPercentage",
      text: "Remise",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
  ];
  const columnsWithDelete = [
    {
      dataField: "productRef",
      text: "Libellé",
      headerAlign: "center",
    },
    {
      dataField: "initialPriceHtc",
      text: "Prix.U.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "sellingPrice",
      text: "Prix.U.V",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "note",
      text: "Note",
      headerAlign: "center",
      formatter: (cell) => cell || "",
    },
    {
      dataField: "quantity",
      text: "Qte",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "6%" };
      },
    },
    {
      dataField: "tva",
      text: "TVA",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "6%" };
      },
    },
    {
      dataField: "htPrice",
      text: "Montant.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "ttPrice",
      text: "Montant.TT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    // {
    //   dataField: "promotionPercentage",
    //   text: "Remise",
    //   align: "center",
    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "8%" };
    //   },
    // },
    {
      dataField: "idProduct",
      text: "Supprimer",
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button className="btn btn-danger">
            <i class="fas fa-trash"></i>
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("productTableData", productTableData);

          setProductTableData(
            productTableData.filter((item) => item.idProduct !== row.idProduct)
          );
        },
      },
    },
  ];
  function handleTableChange({ productTableData }) {
    return productTableData;
  }

  function handleTableChangeRate({ rateTableData }) {
    return rateTableData;
  }

  const onChangeSelected = (selectedOption) => {
    console.log("selected", selectedOption);
    setSelectedOptionRate(selectedOption);
    setRateChoosen(selectedOption.value);
    setRateName(selectedOption.label);
    setRateCode(selectedOption.customElements.code);
    setRateType(selectedOption.customElements.type);
    setRateTypeTax(selectedOption.customElements.typeTax);
    setRateTypeTVA(selectedOption.customElements.typeTVA);
    setRateSelectPlaceHolder(selectedOption.label);
    setValueRate(selectedOption.customElements.value);
  };
  const onChangeValueRateHandler = (event) => {
    setValueRate(event.target.value);
  };
  const onChangeRefBillHandler = (event) => {
    setRefBill(event.target.value);
  };
  const blocRefFacture = () => {
    if (rateTypeTax === 2 && rateType === 1) {
      return (
        <div className="col-md-5">
          <label>Référence facture:</label>
          <input
            type="Ref"
            className="form-control"
            placeholder="Ajouter Référence"
            value={refBill}
            onChange={onChangeRefBillHandler}
          />
        </div>
      );
    } else {
      return <div className="col-md-5"></div>;
    }
  };
  const blocRates = () => {
    if (rateChoosen !== null) {
      if (rateTypeTax === 1) {
        return (
          <>
            <div className="col-md-6">
              <label>Valeur:</label>
              <input
                onChange={onChangeValueRateHandler}
                type="number"
                value={valueRate}
                min="0"
                id="unitPrice"
                className="form-control"
                disabled
              />
            </div>
            {blocRefFacture()}
          </>
        );
      } else if (rateTypeTax === 2) {
        return (
          <>
            <div className="col-md-6">
              <label>Valeur:</label>
              <input
                onChange={onChangeValueRateHandler}
                type="number"
                value={valueRate}
                min="0"
                id="unitPrice"
                className="form-control"
              />
            </div>
            {blocRefFacture()}
          </>
        );
      }
    }
  };
  const onAddTaxeToList = (event) => {
    let rateId = null;
    let exist = false;
    let indexInRateTable;
    try {
      rateTableData.forEach((element, index) => {
        console.log("element", element);

        if (element.code === rateCode) {
          indexInRateTable = index;
          exist = true;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }
    console.log("exist", exist);
    if (rateChoosen === null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Sélectionnez un taxe ");
    }
    if (valueRate == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le valeur est vide ! ");
    } else {
      if (!exist) {
        setRateTableData((previoustate) => [
          ...previoustate,
          {
            idRate: rateChoosen,
            name: rateName,
            value: valueRate,
            code: rateCode,
            type: rateType,
            typeTax: rateTypeTax,
            typeTVA: rateTypeTVA,
            refBill: refBill,
          },
        ]);
      } else if (exist) {
        let rateUpdateValue = rateTableData[indexInRateTable];

        if (rateTableData[indexInRateTable].value !== valueRate) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé la valeur de " + rateName
          );
        }
        rateUpdateValue.idRate = rateChoosen;
        rateUpdateValue.name = rateName;
        rateUpdateValue.value = valueRate;
        rateUpdateValue.code = rateCode;
        rateUpdateValue.type = rateType;
        rateUpdateValue.typeTax = rateTypeTax;
        rateUpdateValue.typeTVA = rateTypeTVA;
        rateUpdateValue.refBill = refBill;
        let modelData = update(rateTableData, {
          [indexInRateTable]: { $merge: rateUpdateValue },
        });

        setRateTableData(modelData);
      }
      setRefBill("");
      setRateChoosen(null);
      setRateSelectPlaceHolder("choisir une taxe ou frais");
      setRateName("");
      setRateCode("");
      setRateType("");
      setValueRate("");
    }
  };
  function buttonFormatter(cell, row) {
    if (row.typeTax === 1) {
      if (row.typeTVA === 1) {
        // return <span>Tax, avant TVA</span>;
        return <span>Tax, sur HTC</span>;
      } else if (row.typeTVA === 2) {
        // return <span>Tax, après TVA</span>;
        return <span>Tax, sur TTC</span>;
      }
    } else if (row.typeTax === 2) {
      if (row.type === 1) {
        return <span>Charge, avec facture</span>;
      } else if (row.type === 2) {
        return <span>Charge, sans facture</span>;
      }
    }
  }
  const columnsRate = [
    {
      dataField: "code",
      text: "Code",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "name",
      text: "Libellé",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "typeTax",
      text: "Type",
      formatter: buttonFormatter,
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "value",
      text: "Valeur %",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "idRate",
      text: "Supprimer",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button className="btn btn-danger">
            <i class="fas fa-trash"></i>
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("rateTableData cell", rateTableData);

          setRateTableData(
            rateTableData.filter((item) => item.idRate !== row.idRate)
          );
        },
      },
    },
  ];

  const getProdcutsAndDevisByWarehouse = (event) => {
    if (warehouseSourceId !== 0) {
      setProductBloc(true);

      SellingService.getAllBDCNotArchived(getCurrentUserId(), warehouseSourceId)
        .then((response) => {
          if (Object.keys(response.data)[0] === "empty") {
            setAvailableBDCSelectPlaceHolder("Vide");
          } else if (Object.keys(response.data)[0] === "success") {
            let backendData = [{}];
            response.data.success.map((element) => {
              let elem = { value: element, label: element };
              backendData.push(elem);
            });
            setAllAvailableBDC(backendData);
            setAvailableBDCSelectPlaceHolder("Choisir...");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        });

      SellingService.getAllDevisNotRelatedToBDCeNotArchived(
        getCurrentUserId(),
        warehouseSourceId
      )
        .then((response) => {
          console.log("DevisBC", response);

          if (Object.keys(response.data)[0] === "empty") {
            setAvailableDevisNotRelatedToBDCSelectPlaceHolder("Vide");
          } else if (Object.keys(response.data)[0] === "success") {
            let backendData = [{}];
            response.data.success.map((element) => {
              let elem = { value: element, label: element };
              backendData.push(elem);
            });
            setAllAvailableDevisNotRelatedToBdc(backendData);
            setAvailableDevisNotRelatedToBDCSelectPlaceHolder("Choisir...");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        });
      SellingService.getAllProductsOnSale(
        getCurrentUserId(),
        1,
        warehouseSourceId
      )
        .then((response) => {
          if (response.data.success) {
            // console.log("setWarehousesSource", response.data.success);
            // setWarehousesSource(response.data.success);
            console.log(response.data.success);
            setAllProducts([{}]);
            // setAvailableProducts(response.data.success);
            response.data.success &&
              response.data.success.map((element) => {
                let exist = false;
                if (allProducts.length !== 0) {
                  for (let index = 0; index < allProducts.length; index++) {
                    if (allProducts[index].value === element.product?.id) {
                      exist = true;
                      break;
                    }
                  }
                }
                let codeProduct = "*";
                if (element.product.productCode !== undefined) {
                  codeProduct = element.product.productCode;
                }
                let barCodeProduct = "*";
                if (element.product.barcode) {
                  barCodeProduct = element.product.barcode;
                }
                let label =
                  codeProduct +
                  "-" +
                  barCodeProduct +
                  "-" +
                  element.product.name;
                if (element.product?.id !== undefined && exist === false) {
                  setAllProducts((oldArray) => [
                    ...oldArray,
                    {
                      value: element.product.id,
                      label: label,
                      customElements: {
                        quantity: element.quantity,
                        tva: element.product.tva,
                        price: element.priceSale,
                        devise: element.devise,
                      },
                    },
                  ]);
                  setAvailableProducts((oldArray) => [
                    ...oldArray,
                    element.product,
                  ]);
                }
              });
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : pas de dépôt");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connexion");
        });
      // ProductOrderService.getAllDevisSellByIdUserAndArchived(
      //   getCurrentUserId(),
      //   0
      // )
      //   .then((response) => {
      //     if (Object.keys(response.data)[0] === "empty") {
      //       setAvailableDevisSelectPlaceHolder("Vide");
      //     } else if (Object.keys(response.data)[0] === "success") {
      //       let backendData = [{}];
      //       response.data.success.map((element) => {
      //         let elem = { value: element, label: element };
      //         backendData.push(elem);
      //       });
      //       setAllAvailableDevis(backendData);
      //       setAvailableDevisSelectPlaceHolder("Choisir...");
      //     }
      //   })
      //   .catch(() => {
      //     setOpenErrorAlert(true);
      //     setErrorAlertText("Erreur : pas de devis");
      //   });
      // ProductService.getAllProductsOnSaleAndWarehouse(
      //   getCurrentUserId(),
      //   1,
      //   warehouseSourceId
      // )
      //   .then((response) => {
      //     setAvailableProducts(response.data["Allproducts"]);
      //   })
      //   .catch(() => {
      //     setOpenErrorAlert(true);
      //     setErrorAlertText("Erreur : pas de produit");
      //   });
    }
  };
  function blocProducts() {
    return (
      <div>
        <div class="row">
          <div className="col-sm-12">
            {/* {createBDCFromDevis === false && (
                <div>
                  <div class="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>
                          Vous pouvez choisir la référence d'un bon de commande
                          existant pour obtenir ses produits
                        </label>
                        <div className="input-group">
                          <div
                            className="input-group-prepend"
                            style={{ width: "95%" }}
                          >
                            <Select
                              styles={styles}
                              closeMenuOnSelect={true}
                              components={animatedComponents}
                              defaultValue={availableBDCSelectedOption}
                              onChange={onChangeBDCReferenceHandler}
                              options={allAvailableBDC}
                              placeholder={availableBDCSelectPlaceHolder}
                            />
                          </div>

                          <div className=" input-group-append">
                            <button
                              onClick={onGetBDCByReference}
                              type="button"
                              class="btn btn-dark"
                            >
                              {" "}
                              <i class="fas  fa-solid fa-arrow-down"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <div>
                          <label>Choisir un produit</label>

                          <Select
                            closeMenuOnSelect={true}
                            components={animatedComponents}
                            defaultValue={selectedOption}
                            onChange={onChangeSelectedProduct}
                            options={allProducts}
                            placeholder={productSelectPlaceHolder}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label htmlFor="inputClientCompany">
                          Prix.U.H.T ( {estimDevise})
                        </label>
                        <input
                          onChange={onChangeUnitPriceHandler}
                          value={estimUnitPrice}
                          disabled="true"
                          min="0"
                          id="unitPrice"
                          className="form-control"
                        />
                      
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label htmlFor="inputClientCompany">
                          TVA ({estimTva}%)
                        </label>
                        <input
                          value={estimTva}
                          disabled="true"
                          onChange={onChangeTvaHandler}
                          min="0"
                          id="tva"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label htmlFor="inputClientCompany">
                          Quantité ({estimQte})
                        </label>
                        <input
                          onChange={onChangeQuantityHandler}
                          value={quantity}
                          type="number"
                          min="0"
                          id="inputClientCompany"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>Choisir un Lot</label>

                        <Select
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={selectedOptionLot}
                          onChange={onChangeSelectedLot}
                          options={allLot}
                          placeholder={lotSelectPlaceHolder}
                        />
                      </div>
                    </div>
                  </div>
                 
                  <div class="row">
                    <div className="col-sm-12  text-center">
                      <button
                        style={{ marginBottom: 20 }}
                        className="btn btn-dark"
                        onClick={onAddProductToList}
                      >
                        <i class="fas fa-plus"></i>
                        Liste des achats{" "}
                      </button>
                    </div>
                  </div>

                  <div class="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        {productTableData && (
                          <ToolkitProvider
                            keyField="idProduct"
                            data={productTableData}
                            columns={columnsWithDelete}
                            onTableChange={handleTableChange}
                          >
                            {(props) => (
                              <div>
                                <div className="row">
                                  <BootstrapTable
                                    {...props.baseProps}
                                    striped
                                    hover
                                    condensed
                                  />
                                </div>
                              </div>
                            )}
                          </ToolkitProvider>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )} */}
            {createBDCFromDevis && (
              <div class="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    {productTableData && (
                      <ToolkitProvider
                        keyField="idProduct"
                        data={productTableData}
                        columns={columns}
                      >
                        {(props) => (
                          <div>
                            <div className="row">
                              <BootstrapTable
                                {...props.baseProps}
                                striped
                                hover
                                condensed
                              />
                            </div>
                          </div>
                        )}
                      </ToolkitProvider>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
  const onUploadFileHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      setBCFile(e.target.files[0]);
    }
  };
  const onChangeRefBCHandler = (event) => {
    setRefBC(event.target.value);
  };
  const blocButtonAddRates = () => {
    if (rateChoosen !== null) {
      return (
        <div className="row">
          <div className="col-md-8"></div>
          <div className="col-md-4">
            <button class="btn btn-dark  float-right" onClick={onAddTaxeToList}>
              <i class="fas fa-plus"></i>
              Ajouter taxe
            </button>
          </div>
        </div>
      );
    }
  };
  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            {/* <div class="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <label>Choisir le dépôt </label>
                  <div className="input-group">
                    <div
                      className="input-group-prepend"
                      style={{ width: "95%" }}
                    >
                      <Select
                        styles={styles}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        defaultValue={selectedOption}
                        onChange={onChangeSelectedWarehouseSource}
                        options={allWarehouseSource}
                        placeholder={warehouseSelectPlaceHolder}
                      />
                    </div>
                    <div className=" input-group-append">
                      <button
                        onClick={getProdcutsAndDevisByWarehouse}
                        type="button"
                        class="btn btn-dark"
                      >
                        <i class="fas  fa-solid fa-arrow-down"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            {blocProducts()}

            {/*  */}
          </div>
        );
      case 1:
        return (
          <div>
            <div class="row">
              <div className="col-sm-4">
                <div className="form-group">
                  <label htmlFor="inputClientCompany">
                    Référence <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    value={refBC}
                    required="required"
                    onChange={onChangeRefBCHandler}
                    type="text"
                    id="refBC"
                    className="form-control"
                    placeholder="Saisir..."
                  />
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label htmlFor="inputClientCompany">
                    Titre <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    value={ordreTitle}
                    required="required"
                    onChange={onChangeOrdreTitleHandler}
                    type="text"
                    id="inputClientCompany"
                    className="form-control"
                    placeholder="Saisir..."
                  />
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label htmlFor="inputClientCompany">Choisir le client </label>
                  <Select
                    isDisabled={createBDCFromDevis}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={clientSelectedOption}
                    onChange={onChangeSelectedClient}
                    options={allClients}
                    placeholder={clientSelectPlaceHolder}
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <label>Choisir le type de Remise </label>
                  <select
                    disabled={createBDCFromDevis}
                    value={discountType}
                    onChange={onChangeDiscountTypeHandler}
                    className="form-control select2"
                    style={{ width: "100%" }}
                  >
                    <option key={1} value={"pourcentage"} selected="selected">
                      Pourcentage
                    </option>
                    <option key={2} value={"montant"}>
                      Montant
                    </option>
                  </select>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label htmlFor="inputClientCompany">Remise</label>
                  <input
                    disabled={createBDCFromDevis}
                    value={discount}
                    onChange={onChangeDiscountHandler}
                    type="number"
                    min="0"
                    id="inputRemiseClientCompany"
                    className="form-control"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <label htmlFor="inputDescription">
                    Note <span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    value={ordreDesignation}
                    placeholder="Saisir..."
                    onChange={onChangeOrdreDesignationHandler}
                    id="inputDescription"
                    className="form-control"
                    rows={4}
                    defaultValue={""}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div class="form-group">
                  <label for="exampleInputFile">Bon de commande </label>
                  <div class="input-group">
                    <div class="custom-file">
                      <input
                        accept="application/pdf, .jpg, .jpeg, .png"
                        type="file"
                        className="custom-file-input"
                        id="exampleInputFile"
                        onChange={onUploadFileHandler}
                      />
                      <label class="custom-file-label" for="exampleInputFile">
                        Entrer le fichier de BC
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <label>Choisir une taxe</label>
                  <Select
                    styles={styles}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOptionRate}
                    onChange={onChangeSelected}
                    options={allRates}
                    placeholder={rateSelectPlaceHolder}
                  />
                </div>
              </div>
              {blocRates()}
            </div>
            {blocButtonAddRates()}

            <br />
            <div className="row">
              <div className="col-md-12">
                {rateTableData && (
                  <ToolkitProvider
                    keyField="rateTable"
                    data={rateTableData}
                    columns={columnsRate}
                    onTableChange={handleTableChangeRate}
                  >
                    {(props) => (
                      <div>
                        <div className="row">
                          <BootstrapTable
                            {...props.baseProps}
                            striped
                            hover
                            condensed
                          />
                        </div>
                      </div>
                    )}
                  </ToolkitProvider>
                )}
              </div>
            </div>
            <div className="row bg-light">
              <div className="col-sm-6">
                <div className="form-group">
                  <label htmlFor="inputClientCompany">Prix total Ht </label>
                  <input
                    value={bcPriceHt.toLocaleString(undefined, {
                      maximumFractionDigits: 3,
                    })}
                    disabled="true"
                    id="inputClientCompany"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label htmlFor="inputClientCompany">Prix total Tt </label>
                  <input
                    value={
                      discount !== 0
                        ? bcPriceTt.toLocaleString(undefined, {
                            maximumFractionDigits: 3,
                          })
                        : bcPriceTt.toLocaleString(undefined, {
                            maximumFractionDigits: 3,
                          })
                    }
                    disabled="true"
                    id="inputClientCompany"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-sm-12"></div>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="row">
            <span class="text-dark">
              Avant de cliquer sur terminé, vous devez être sûr des informations
              saisies
            </span>
          </div>
        );
      default:
        return "Unknown step";
    }
  }

  const onAddProductToList = (event) => {
    let productRef = null;
    let exist = false;
    let indexInDataTable;
    try {
      productMapById.forEach((element, index) => {
        if (element.id === productId) {
          indexInDataTable = index;
          exist = true;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }
    try {
      availableProducts.forEach((element) => {
        if (element.id === productId) {
          productRef = element.name;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }
    if (productId === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Sélectionnez un produit ");
    } else if (quantity === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText(
        "Erreur : la quantité du produit doit être supérieur à zéro "
      );
    } else if (unitPrice === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText(
        "Erreur : le prix unitaire doit être supérieur à zéro "
      );
    } else {
      if (modeProduct === 0) {
      }
      let result = UtilsFormule.CalculatePromotionProductPurchase(
        promotionPercentage,
        promotionType,
        montantDevis,
        quantity,
        tva
      );
      console.log("result add product table", result);
      let promotionAmountOrPersentage = result[0];
      let sellingPrice = result[1];
      let promotionpercent = result[2];
      let ttPrice = result[3];

      if (!exist) {
        setProductMapById((previoustate) => [
          ...previoustate,
          {
            productRef: productRef,
            idProduct: productId,
            initialPriceHtc: montantDevis,
            quantity: quantity,
            tva: tva,
            currency: deviseChoosen,
            currencyPrice: unitPrice,
            exchangeRate: tauxChange,
            isImport: modeProduct,
            sellingPrice: sellingPrice,
            idLot: idLot,
            htPrice: promotionAmountOrPersentage,
            ttPrice: ttPrice,
            promotionPercentage: promotionpercent,
          },
        ]);
        setProductTableData((previoustate) => [
          ...previoustate,
          {
            productRef: productRef,
            idProduct: productId,
            initialPriceHtc: montantDevis,
            quantity: quantity,
            tva: tva,
            idLot: idLot,
            sellingPrice: sellingPrice,
            currency: deviseChoosen,
            currencyPrice: unitPrice,
            exchangeRate: tauxChange,
            isImport: modeProduct,
            htPrice: promotionAmountOrPersentage,
            ttPrice: ttPrice,
            promotionPercentage: promotionpercent,
          },
        ]);
      } else if (exist) {
        let productUpdateValue = productTableData[indexInDataTable];
        productUpdateValue.promotionPercentage = promotionPercentage;
        productUpdateValue.initialPriceHtc = montantDevis;
        productUpdateValue.quantity = quantity;
        productUpdateValue.tva = tva;
        productUpdateValue.sellingPrice = sellingPrice;
        productUpdateValue.htPrice = promotionAmountOrPersentage;
        productUpdateValue.ttPrice = ttPrice;

        let modelData = update(productTableData, {
          [indexInDataTable]: { $merge: productUpdateValue },
        });

        let tableData = update(productMapById, {
          [indexInDataTable]: { $merge: productUpdateValue },
        });
        if (productTableData[indexInDataTable].initialPriceHtc !== unitPrice) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le prix unitaire du produit :  " +
              productRef
          );
        } else if (
          productTableData[indexInDataTable].promotionType !== promotionType
        ) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le type de promotion du produit :  " +
              productRef
          );
        } else if (
          productTableData[indexInDataTable].promotionPercentage !==
          promotionPercentage
        ) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé la promotion du produit : " + productRef
          );
        } else if (productTableData[indexInDataTable].quantity !== quantity) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé la quantité du produit : " + productRef
          );
        } else if (productTableData[indexInDataTable].tva !== tva) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le tva du produit : " + productRef
          );
        }

        setProductMapById(tableData);
        setProductTableData(modelData);
      }
    }
    etatInitial();

    console.log("productTableData ", productTableData);
  };
  function etatInitial() {
    setSelectedOption(null);
    setProductSelectPlaceHolder("Choisir...");
    setUnitPrice(0);
    setQuantity(0);
    setTva(0);
    setSelectedOptionMode(null);
    setPromotionType("pourcentage");
    setPromotionPercentage(0);
    setSelectedOptionLot(null);
    setLotSelectPlaceHolder("Choisir...");
  }

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>

                <li className="breadcrumb-item">
                  <Link to="/bonCommandeVente" style={{ color: "black" }}>
                    Les bons de commandes
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "black" }}
                >
                  Ajouter
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <div className={classes.root}>
                    <Stepper
                      // alternativeLabel
                      activeStep={activeStep}
                      // style={{ marginTop: 4 }}
                    >
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </div>
                </div>

                {activeStep === steps.length ? (
                  <div class="card-body">
                    <div class="row" style={{ marginTop: 2 }}></div>
                    Toutes les étape ont complétées avec succès
                    <Button onClick={handleReset} className={classes.button}>
                      Réinitialiser
                    </Button>
                  </div>
                ) : (
                  <div>
                    <div class="card-body">{getStepContent(activeStep)}</div>
                    <div class="card-footer" style={{ marginTop: "1%" }}>
                      <button
                        disabled={activeStep === 0}
                        className="btn btn-light"
                        onClick={handleBack}
                      >
                        Précédent
                      </button>

                      <button class="btn btn-dark" onClick={handleNext}>
                        {activeStep === steps.length - 1
                          ? "Terminer"
                          : "Suivant"}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default ValidateDevisToBCVente;
